import { Component, OnDestroy, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { of, from, Subscription, Subject } from 'rxjs';
import { map, switchMap, concatMap, filter, debounceTime, finalize } from 'rxjs/operators';

import { environment } from 'src/environments/environment';
import { round1, round2 } from 'src/app/shared/round';

import { Document, DocItems, DocInheritanceRule } from 'src/app/shared/document';

import { GlobalSettingsData } from 'src/app/shared/global-settings-data'
import { GetglobalsettingsService } from 'src/app/services/getglobalsettings.service'

import { ProductApiService, StockResult } from 'src/app/services/product-api.service';
import { ClientApiService } from 'src/app/services/client-api.service';
import { RestApiService } from 'src/app/services/rest-api.service';

@Component({
  selector: 'app-new-document-dlg-process-tran-move',
  templateUrl: './new-document-dlg-process-tran-move.component.html',
  styleUrls: ['./new-document-dlg-process-tran-move.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class NewDocumentDlgProcessTranMoveComponent implements OnInit, OnChanges, OnDestroy {

  private globalSettinsData: GlobalSettingsData;
  private _productInfoQuery: Subscription;
  private _depChildQuery: Subscription;

  /*
   * Consider that parentDocument may have or may NOT have items property filled with [actual] docItems
   */
  @Input() parentDocument: Document;

  /*
   * Therefore, to keep source object untouched (immutable ????)
   * we will expect alone/independent copy of DocItems as Input parameter
   * 
   */

  @Input() docItems: DocItems[];

  newDocItems: DocItems[] = [];

  @Input() newDocument: Document;

  @Input() newDocuments: Document[];

  public get hasParentDocument(): boolean { return (this.parentDocumentId && true); }

  @Input() command: number = 0;   /* Command to child components what to do
                                   *
                                   * 0 - nothing / prepare
                                   * 1 - go
                                   * 2 - clean
                                   * 3 - reset to initial state
                                   * 
                                   */
  parentDocumentId: number;

  childDocuments: Document[];

  sourceDocItems: DocItems[];

  blocked: boolean = false;

  moveAction: number = 1;

  stock1: number;
  stock2: number;

  doNotCheckSource: boolean = false;

  @Input() selectedActions: any = [1, 3];

  private createNewDocument$ = new Subject<{ ndi: Document, chk: boolean }>();
  private _creatNewDoc: Subscription;

  private newDocumentProcess$ = new Subject<number>();
  private currencyQuery: Subscription;

  @Output() onCreateNewDocuments = new EventEmitter<Document[]>();

  constructor(
    private restApi: RestApiService,
    private globalsettingsservice: GetglobalsettingsService,
    private cliApi: ClientApiService,
    private prodApi: ProductApiService,
  ) { }

  createNewDocumentProcessSubscription() {

    let rowSortIndex: number;

    this.currencyQuery =
      this.newDocumentProcess$
        .pipe(
          debounceTime(300),

          switchMap(options => { this.blocked = true; return of(options); }),

          concatMap(options => this.restApi.getCurrencyInfoByID(options).pipe(
            filter(rate => (rate && (rate.length > 0))),
            concatMap(rate => {
              this.newDocument.DOCRATEVAL = rate[0].CURRATE;
              this.newDocument.items = [];
              this.newDocItems = [];

              rowSortIndex = 0;
              //environment.production || console.table(this.newDocument);
              return of(this.newDocument);
            }),

            concatMap(ndc => this.cliApi.getChildDepartmentsById(ndc.DOCCLIDEPID, ndc.DOCPCOCLIID).pipe(
              map(d => {
                if (d && (d.length > 0)) {
                  ndc.DOCPCODEPID = d[0].CLIID; return ndc;
                }
              })
            )),

            concatMap(ndc => this.cliApi.getChildDepartmentsById(ndc.DOCMANDEPID, ndc.DOCLCOCLIID).pipe(
              map(d => {
                if (d && (d.length > 0)) {
                  ndc.DOCLCODEPID = d[0].CLIID;
                }
              return this.sourceDocItems;
              })
            )),

            concatMap(items => from(items)),

            concatMap(di => {
              //environment.production || console.table(di);
              //environment.production || console.log('*** NewDocumentDlgProcessTranMoveComponent in createNewDocumentProcessSubscription: ndi ' + di.PRODCODE + ' Q: ' + di.DOCITEMQTY);

              rowSortIndex += 10;

              let adi: DocItems = {
                ...di,
                ... {
                  DOCITEMID: -2,
                  cloneIndex: 0,
                  U4ETKA: null,
                  DOCITEMCURRID: this.newDocument.DOCCURRID,
                  DOCITEMCRATE: this.newDocument.DOCRATEVAL,
                  PAYITEMCLIID: rowSortIndex,
                  PRODVAT: di.PRODVAT ?? this.globalSettinsData.vatValue,
                }
              };

              return of(adi);
            }),

            /*
              * Check is there any source
              */

            filter(ndi => ndi.DOCITEMQTY > 0),  // Continue only if there is product on the stock

            concatMap((ndi: DocItems) => this.prodApi.getProductStockBefore(ndi.PRODID, this.newDocument.DOCMANCLIID, this.newDocument.DOCMANDEPID, new Date(this.newDocument.DOCDATE)).pipe(map(stock => {
              ndi.DOCITEMGLOBALSTOCK = (stock as StockResult[])[0]?.stock ?? 0;

              environment.production || console.log('*** NewDocumentDlgProcessTranMoveComponent in getProductStockBefore: checking ' + ndi.PRODCODE + ' Q: ' + ndi.DOCITEMQTY + ' - Check source stock: ' + ((stock as StockResult[])[0]?.stock ?? 0));
              //environment.production || console.table(di);

              if (!this.doNotCheckSource && (ndi.DOCITEMQTY > ndi.DOCITEMGLOBALSTOCK)) {
                ndi.DOCITEMQTY = ndi.DOCITEMGLOBALSTOCK;      // Bring only available quantity
              }

              return ndi;
            }))),

            concatMap((ndi: DocItems) => this.prodApi.getProdInfoById(
              ndi.PRODID,
              this.newDocument.DOCMANCLIID,
              this.newDocument.DOCCURRID,
              //
              // It depends on document type ????
              //
              this.globalSettinsData.mainStockId,
              this.globalSettinsData.impCountFlag ? this.globalSettinsData.impStockId : 0,
              this.globalSettinsData.auxCountFlag ? this.globalSettinsData.auxStockId : 0,
              //
              // Is it on actual date or document date
              // Could depends on....
              //
              new Date(this.newDocument.DOCDATE)
            )
              .pipe(map(data => {
                ndi.prodInfo = data[0];

                //environment.production || console.log('*** NewDocumentDlgProcessTranMoveComponent in getProdInfoById: process ' + ndi.PRODCODE + ' Q: ' + ndi.DOCITEMQTY + ' - ProdInfo: ' + JSON.stringify(data));
                //
                //  Finally, after all succesfull checking we could push item to newDocument Items array,
                //
                return ndi;
              }))),

            /*
              * Determine income price to put into receipt
              */
            concatMap((ndi: DocItems) => this.prodApi.getProdIncomePriceById(ndi.PRODID, this.newDocument.DOCMANCLIID, this.newDocument.DOCMANDEPID, this.newDocument.DOCCURRID, ndi.DOCITEMQTY, this.newDocument.DOCDATE).pipe(map(price => {

              environment.production || console.log('*** NewDocumentDlgProcessTranMoveComponent in getProdIncomePriceById: enter ' + JSON.stringify(price));

              ndi.DOCITEMVPRICE = ((price.length > 0) && (price[0].PRODINCOMEPRICE > 0)) ? price[0].PRODINCOMEPRICE : ndi.prodInfo.PRODINPRICE;
              ndi.DOCITEMPRICE = round2(ndi.DOCITEMVPRICE * this.newDocument.DOCRATEVAL);

              ndi.PRODVAT = (ndi.PRODVAT ?? this.globalSettinsData.vatValue);

              ndi.DOCITEMSUM = ndi.DOCITEMPRICE * ndi.DOCITEMQTY;
              ndi.DOCITEMVSUM = ndi.DOCITEMVPRICE * ndi.DOCITEMQTY;

              this.newDocItems.push({ ...ndi });
              //environment.production || console.table(this.newDocument.items);
              //environment.production || console.log('*** NewDocumentDlgProcessTranMoveComponent in getProdIncomePriceById: exit ' + JSON.stringify(ndi));

              return ndi;
            }))),

            finalize(() => {
              this.blocked = false;
              this.onCreateNewDocuments.emit([{ ... this.newDocument, items: this.newDocItems }]);

              //environment.production || console.log('*** NewDocumentDlgProcessTranMoveComponent in newDocumentProcess$: finalize ' + JSON.stringify(this.newDocument));
            }))
          )
        )
        .subscribe();
  }

  processDocItems() {
    console.log('*** NewDocumentDlgProcessTranMoveComponent in processDocItems');
    /*
     * Here we come with newDocument prepared in createNewDocument initial procedure
     *
     * Furthe we have to process document content
     * to prepare the inital template for further processing
     *
     * Target stock already set
     * 
     * Get Actual currency rate for newDocument
     * And process all items when Currency Rate become available
     * 
     * Those one in newDocument.DOCRATEVAL from createNewDocument Dialog would arrive later
     */

    this.newDocumentProcess$.next(this.newDocument.DOCCURRID);
  }

  ngOnChanges(changes: SimpleChanges) {
    for (let propName in changes) {
      let change = changes[propName];

      environment.production || console.log('*** NewDocumentDlgProcessTranMoveComponent ngOnChanges ' + propName + ' (actual): ' + JSON.stringify(change.currentValue));

      switch (propName) {

        case 'newDocument':
          if (this.newDocument) {
          //  this.processDocItems();
          }
          break;

        case 'docItems':
          if (this.docItems) {
            this.sourceDocItems = [... this.docItems];
            //this.processDocItems();
          }
          break;

        case 'parentDocument':
          if (this.parentDocument) {
            //this.processDocItems();
          }
          break;

        case 'command':
          switch (change.currentValue) {
            case 0:
              this.createNewDocumentProcessSubscription();
              break;

            case 1:
              this.processDocItems();
              break;

            case 2:
              this.newDocument.items = [];
              this.onCreateNewDocuments.emit([this.newDocument]);
              break;

            case 3:
              this.newDocument.items = [];
              this.onCreateNewDocuments.emit([]);

              break;
          }
          break;

      }
    }
  }

  ngOnDestroy(): void {
    console.log('*** NewDocumentDlgProcessTranMoveComponent in ngOnDestroy')

    if (this.currencyQuery) { this.currencyQuery.unsubscribe(); }

    if (this._productInfoQuery) { this._productInfoQuery.unsubscribe(); }
    if (this._depChildQuery) { this._depChildQuery.unsubscribe(); }
    if (this._creatNewDoc) { this._creatNewDoc.unsubscribe(); }
  }

  ngOnInit(): void {
    console.log('*** NewDocumentDlgProcessTranMoveComponent in ngOnInit');

    /*
     * TODO: Make subscription to newDocument currency rate, because it is quite complex task to wait the set the rate in the main thread
     * Potentially problematic due to different sources ??????
     */

    this.globalSettinsData = this.globalsettingsservice.getGlobalSettings();
//    this.createNewDocumentProcessSubscription();
}

  stock1Selected(event) {
    console.log('*** NewDocumentDlgProcessTranMoveComponent stock1Selected ' + JSON.stringify(event));

    this.newDocument.DOCMANDEPID = event;
    this.onCreateNewDocuments.emit([this.newDocument]);
}

  stock2Selected(event) {
    console.log('*** NewDocumentDlgProcessTranMoveComponent stock2Selected ' + JSON.stringify(event));

    this.newDocument.DOCCLIDEPID = event;
    this.onCreateNewDocuments.emit([this.newDocument]);
  }

  onProductionMode(event) {
    console.log('*** NewDocumentDlgProcessSpecComponent onProductionMode ' + JSON.stringify(event));
  }
}
